// PPS project statuses and BCS project status have different IDs
// This must match the dbo.Entity table ID

// PPS Project Statuses
export enum ProjectStatuses{
  Quoted = 1,
  Approved = 3,
  POReceived = 5, 
  JobLost = 29,
  RFQ = 44, 
  JobCancelled = 90,
  PRFRaised = 91
}

// BCS Project Statuses
// export enum ProjectStatuses{
//   Quoted = 4,
//   Approved = 5,
//   POReceived = 6, 
//   JobLost = 7,
//   RFQ = 8,
//   JobCancelled = 9,
//   PRFRaised = 10
// }